<template>
  <div class="c-record-detail">
    <!-- info -->
    <div class="c-info">
      <Form class="c-form-wrap" :label-width="80" inline>
        <FormItem label="月份：">
          <span>{{ month }}</span>
        </FormItem>
        <FormItem label="姓名：">
          <span>{{ name }}</span>
        </FormItem>
        <FormItem label="游戏组：">
          <span>{{ game }}</span>
        </FormItem>
        <FormItem label="媒体：">
          <span>{{ media }}</span>
        </FormItem>
      </Form>

      <div>
        <Button type="primary" @click="downData">数据导出</Button>
      </div>
    </div>
    <!-- table -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight">
        <record-detail-table :loading="loading" :height="tableHeight - 10" :data="tableList" :columns="tableCol" @on-sort="sortTable" />
      </Viewport>
    </div>
  </div>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/record_detail_column'
import { HOST_API } from '@/api/config'
import { isArray } from '@/common/js/utils'
import { getGZRecordDetailList } from '@/api/manage.model'
import RecordDetailTable from './components/record-detail-table'

export default {
  name: 'recordDetail',
  mixins: [mixin],
  components: { RecordDetailTable },
  methods: {
    getData() {
      this.$Spin.show()
      getGZRecordDetailList({
        reportMonth: this.month,
        opId: this.opId,
        gameGroupId: this.gameId,
        mediaId: this.mediaId,
        sort: this.sort,
        order: this.order
      })
        .then((data) => {
          this.$Spin.hide()
          isArray(data) && (this.tableList = data)
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    sortTable(params) {
      const { sort, order } = params
      this.sort = sort
      this.order = order
      this.pageIndex = 1
      this.getData()
    },
    downData() {
      window.open(
        `${HOST_API}/api/ptom/guangzKpiData/downDetail?downType=${this.type}&reportMonth=${this.month}&sort=${this.sort}&order=${this.order}&opId=${this.opId}&gameGroupId=${this.gameId}&mediaId=${this.mediaId}&sessionid=${this.$store.state.token}`
      )
    }
  },
  data() {
    return {
      tableHeight: 330,
      month: decodeURI(this.$route.query.month),
      opId: this.$route.query.opId,
      name: decodeURI(this.$route.query.name),
      gameId: this.$route.query.gameId,
      game: decodeURI(this.$route.query.game),
      mediaId: this.$route.query.mediaId,
      media: decodeURI(this.$route.query.media),
      type: this.$route.query.type
    }
  },
  created() {
    const account = [
      'reportTime',
      'name',
      'gameName',
      'mediaName',
      'amount',
      'cpRate',
      'thirtyCreateRoleMoney',
      'thirtySynthesizeCreateRoleMoney',
      'thirtySynthesizeCreateRoleRetain',
      'gameNameReal',
      'remark'
    ]
    const device = [
      'reportTime',
      'name',
      'gameName',
      'mediaName',
      'amount',
      'cpRate',
      'thirtyNewDeviceMoney',
      'thirtySynthesizeDeviceMoney',
      'thirtySynthesizeDeviceRetain',
      'gameNameReal',
      'remark'
    ]
    const role = [
      'reportTime',
      'name',
      'gameName',
      'mediaName',
      'amount',
      'cpRate',
      'thirtyNewRoleMoney',
      'thirtySynthesizeMoney',
      'thirtySynthesizeRetain',
      'gameNameReal',
      'remark'
    ]
    this.tableCol = columns.filter((ret) => {
      if (this.type === 'account') return account.includes(ret.key)
      if (this.type === 'device') return device.includes(ret.key)
      else if (this.type === 'role') return role.includes(ret.key)
    })
    this.getData()
  }
}
</script>
<style lang="scss" scoped>
.c-record-detail {
  ::v-deep .c-info {
    width: 100%;
    margin-bottom: 8px;
    background-color: rgb(242, 242, 242);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 10px;

    .c-form-wrap {
      .ivu-form-item {
        margin-bottom: 0;
      }
    }
  }
}
</style>
